// utils/constants.js

// 广告目标类型
export const OBJECTIVE_TYPE = {
    APP_PROMOTION: 'APP_PROMOTION',
    WEB_CONVERSIONS: 'WEB_CONVERSIONS',
    LEAD_GENERATION: 'LEAD_GENERATION'
}

export const OBJECTIVE_LABEL = {
    [OBJECTIVE_TYPE.APP_PROMOTION]: '应用推广',
    [OBJECTIVE_TYPE.WEB_CONVERSIONS]: '网站转化',
    [OBJECTIVE_TYPE.LEAD_GENERATION]: '销售线索'
}

// 预算模式
export const BUDGET_MODE_LABEL = {
    BUDGET_MODE_DYNAMIC_DAILY_BUDGET: '动态每日预算',
    BUDGET_MODE_TOTAL: '终身预算',
    BUDGET_MODE_INFINITE: '无限预算'
}

// 广告组模式


// ==================== 指标定义（基于API文档） ====================

// 指标枚举
export const METRICS = {
    // 核心指标
    SPEND: 'spend',
    IMPRESSIONS: 'impressions',
    CLICKS: 'clicks',
    CTR: 'ctr',
    CPC: 'cpc',
    CPM: 'cpm',
    CONVERSION: 'conversion',
    COST_PER_CONVERSION: 'cost_per_conversion',
    CONVERSION_RATE_V2: 'conversion_rate_v2',
    GROSS_IMPRESSIONS: 'gross_impressions',
    REAL_TIME_CONVERSION: 'real_time_conversion',
    REAL_TIME_COST_PER_CONVERSION: 'real_time_cost_per_conversion',
    REAL_TIME_CONVERSION_RATE_V2: 'real_time_conversion_rate_v2',
    SKAN_RESULT: 'skan_result',
    SKAN_COST_PER_RESULT: 'skan_cost_per_result',
    SKAN_RESULT_RATE: 'skan_result_rate',
    SKAN_CONVERSION: 'skan_conversion',
    SKAN_COST_PER_CONVERSION: 'skan_cost_per_conversion',
    SKAN_CONVERSION_RATE_V2: 'skan_conversion_rate_v2',

    // 互动指标
    ENGAGEMENTS: 'engagements',
    ENGAGEMENT_RATE: 'engagement_rate',
    LIKES: 'likes',
    COMMENTS: 'comments',
    SHARES: 'shares',
    FOLLOWS: 'follows',
    PROFILE_VISITS: 'profile_visits',
    PROFILE_VISITS_RATE: 'profile_visits_rate',
    CLICKS_ON_MUSIC_DISC: 'clicks_on_music_disc',
    DUET_CLICKS: 'duet_clicks',
    STITCH_CLICKS: 'stitch_clicks',
    SOUND_USAGE_CLICKS: 'sound_usage_clicks',
    ANCHOR_CLICKS: 'anchor_clicks',
    ANCHOR_CLICK_RATE: 'anchor_click_rate',

    // 视频指标
    VIDEO_PLAY_ACTIONS: 'video_play_actions',
    VIDEO_WATCHED_2S: 'video_watched_2s',
    VIDEO_WATCHED_6S: 'video_watched_6s',
    VIDEO_VIEWS_P25: 'video_views_p25',
    VIDEO_VIEWS_P50: 'video_views_p50',
    VIDEO_VIEWS_P75: 'video_views_p75',
    VIDEO_VIEWS_P100: 'video_views_p100',
    AVERAGE_VIDEO_PLAY: 'average_video_play',
    ENGAGED_VIEW: 'engaged_view',
    PAID_ENGAGED_VIEW: 'paid_engaged_view',
    ENGAGED_VIEW_15S: 'engaged_view_15s',
    PAID_ENGAGED_VIEW_15S: 'paid_engaged_view_15s',

    // 应用转化指标
    APP_INSTALL: 'app_install',
    COST_PER_APP_INSTALL: 'cost_per_app_install',
    REAL_TIME_APP_INSTALL: 'real_time_app_install',
    REAL_TIME_COST_PER_APP_INSTALL: 'real_time_cost_per_app_install',
    REGISTRATION: 'registration',
    COST_PER_REGISTRATION: 'cost_per_registration',
    REGISTRATION_RATE: 'registration_rate',
    TOTAL_REGISTRATION: 'total_registration',
    PURCHASE: 'purchase',
    COST_PER_PURCHASE: 'cost_per_purchase',
    PURCHASE_RATE: 'purchase_rate',
    TOTAL_PURCHASE: 'total_purchase',
    TOTAL_PURCHASE_VALUE: 'total_purchase_value',
    PURCHASE_ROAS: 'total_active_pay_roas',
    APP_EVENT_ADD_TO_CART: 'app_event_add_to_cart',
    COST_PER_APP_EVENT_ADD_TO_CART: 'cost_per_app_event_add_to_cart',
    CHECKOUT: 'checkout',
    COST_PER_CHECKOUT: 'cost_per_checkout',
    VIEW_CONTENT: 'view_content',
    COST_PER_VIEW_CONTENT: 'cost_per_view_content',
    NEXT_DAY_OPEN: 'next_day_open',
    DAY7_RETENTION: 'day7_retention',
    ADD_PAYMENT_INFO: 'add_payment_info',
    COST_PER_ADD_PAYMENT_INFO: 'cost_per_add_payment_info',
    LAUNCH_APP: 'launch_app',
    COST_PER_LAUNCH_APP: 'cost_per_launch_app',
    COMPLETE_TUTORIAL: 'complete_tutorial',
    COST_PER_COMPLETE_TUTORIAL: 'cost_per_complete_tutorial',

    // SKAN指标
    SKAN_APP_INSTALL: 'skan_app_install',
    SKAN_COST_PER_APP_INSTALL: 'skan_cost_per_app_install',
    SKAN_APP_INSTALL_WITHHELD: 'skan_app_install_withheld',
    SKAN_REGISTRATION: 'skan_registration',
    SKAN_COST_PER_REGISTRATION: 'skan_cost_per_registration',
    SKAN_PURCHASE: 'skan_purchase',
    SKAN_COST_PER_PURCHASE: 'skan_cost_per_purchase',
    SKAN_TOTAL_PURCHASE_VALUE: 'skan_total_purchase_value',
    SKAN_TOTAL_REPETITIVE_ACTIVE_PAY_ROAS: 'skan_total_repetitive_active_pay_roas',

    // 网站指标
    COMPLETE_PAYMENT: 'complete_payment',
    COST_PER_COMPLETE_PAYMENT: 'cost_per_complete_payment',
    COMPLETE_PAYMENT_ROAS: 'complete_payment_roas',
    TOTAL_LANDING_PAGE_VIEW: 'total_landing_page_view',
    COST_PER_LANDING_PAGE_VIEW: 'cost_per_landing_page_view',
    LANDING_PAGE_VIEW_RATE: 'landing_page_view_rate',
    WEBSITE_TOTAL_ENGAGED_SESSION: 'website_total_engaged_session',
    WEBSITE_ENGAGED_SESSION_RATE: 'website_engaged_session_rate',
    WEBSITE_COST_PER_ENGAGED_SESSION: 'website_cost_per_engaged_session',
    TOTAL_PAGEVIEW: 'total_pageview',
    COST_PER_PAGEVIEW: 'cost_per_pageview',
    BUTTON_CLICK: 'button_click',
    COST_PER_BUTTON_CLICK: 'cost_per_button_click',
    ONLINE_CONSULT: 'online_consult',
    COST_PER_ONLINE_CONSULT: 'cost_per_online_consult',
    USER_REGISTRATION: 'user_registration',
    COST_PER_USER_REGISTRATION: 'cost_per_user_registration',
    PAGE_CONTENT_VIEW_EVENTS: 'page_content_view_events',
    COST_PER_PAGE_CONTENT_VIEW_EVENT: 'cost_per_page_content_view_event',
    WEB_EVENT_ADD_TO_CART: 'web_event_add_to_cart',
    COST_PER_WEB_EVENT_ADD_TO_CART: 'cost_per_web_event_add_to_cart',
    ON_WEB_ORDER: 'on_web_order',
    COST_PER_ON_WEB_ORDER: 'cost_per_on_web_order',
    INITIATE_CHECKOUT: 'initiate_checkout',
    COST_PER_INITIATE_CHECKOUT: 'cost_per_initiate_checkout',
    ADD_BILLING: 'add_billing',
    COST_PER_ADD_BILLING: 'cost_per_add_billing',
    PAGE_EVENT_SEARCH: 'page_event_search',
    COST_PER_PAGE_EVENT_SEARCH: 'cost_per_page_event_search',
    FORM: 'form',
    COST_PER_FORM: 'cost_per_form',
    DOWNLOAD_START: 'download_start',
    COST_PER_DOWNLOAD_START: 'cost_per_download_start',
    ON_WEB_ADD_TO_WISHLIST: 'on_web_add_to_wishlist',
    COST_PER_ON_WEB_ADD_TO_WISHLIST: 'cost_per_on_web_add_to_wishlist',
    ON_WEB_SUBSCRIBE: 'on_web_subscribe',
    COST_PER_ON_WEB_SUBSCRIBE: 'cost_per_on_web_subscribe',

    // TikTok站内指标
    ONSITE_TOTAL_PURCHASE: 'onsite_total_purchase',
    ONSITE_COST_PER_PURCHASE: 'onsite_cost_per_purchase',
    ONSITE_PURCHASES_ROAS: 'onsite_purchases_roas',
    ONSITE_TOTAL_CHECKOUT_INITIATION: 'onsite_total_checkout_initiation',
    ONSITE_COST_PER_CHECKOUT_INITIATION: 'onsite_cost_per_checkout_initiation',
    ONSITE_TOTAL_ADD_TO_CART: 'onsite_total_add_to_cart',
    ONSITE_COST_PER_ADD_TO_CART: 'onsite_cost_per_add_to_cart',
    ONSITE_TOTAL_PRODUCT_DETAILS_PAGE_VIEW: 'onsite_total_product_details_page_view',
    ONSITE_COST_PER_PRODUCT_DETAILS_PAGE_VIEW: 'onsite_cost_per_product_details_page_view',
    ONSITE_UNIQUE_REGISTRATION: 'onsite_unique_registration',
    ONSITE_COST_PER_UNIQUE_REGISTRATION: 'onsite_cost_per_unique_registration',
    ONSITE_FORM: 'onsite_form',
    ONSITE_COST_PER_FORM: 'onsite_cost_per_form',
    ONSITE_DOWNLOAD_START: 'onsite_download_start',
    ONSITE_COST_PER_DOWNLOAD_START: 'onsite_cost_per_download_start',

    // 离线指标
    OFFLINE_SHOPPING_EVENTS: 'offline_shopping_events',
    OFFLINE_COST_PER_SHOPPING_EVENT: 'cost_per_offline_shopping_event',
    OFFLINE_SHOPPING_EVENTS_ROAS: 'offline_shopping_events_roas',
    OFFLINE_CONTACT_EVENTS: 'offline_contact_events',
    OFFLINE_COST_PER_CONTACT_EVENT: 'cost_per_offline_contact_event',
    OFFLINE_FORM_EVENTS: 'offline_form_events',
    OFFLINE_COST_PER_FORM_EVENT: 'cost_per_offline_form_event',

    // 互动插件指标
    INTERACTIVE_ADD_ON_IMPRESSIONS: 'interactive_add_on_impressions',
    INTERACTIVE_ADD_ON_DESTINATION_CLICKS: 'interactive_add_on_destination_clicks',
    INTERACTIVE_ADD_ON_ACTIVITY_CLICKS: 'interactive_add_on_activity_clicks',
    COUNTDOWN_STICKER_RECALL_CLICKS: 'countdown_sticker_recall_clicks',

    // 消息指标
    MESSAGING_TOTAL_CONVERSATION_TIKTOK_DIRECT_MESSAGE: 'messaging_total_conversation_tiktok_direct_message',
    MESSAGING_COST_PER_CONVERSATION_TIKTOK_DIRECT_MESSAGE: 'messaging_cost_per_conversation_tiktok_direct_message',
    MESSAGING_TOTAL_CONVERSATION_INSTANT_MESSAGING_APP: 'messaging_total_conversation_instant_messaging_app',
    MESSAGING_COST_PER_CONVERSATION_INSTANT_MESSAGING_APP: 'messaging_cost_per_conversation_instant_messaging_app'
}

// 指标标签
export const METRIC_LABELS = {
    [METRICS.SPEND]: '消耗',
    [METRICS.IMPRESSIONS]: '展示次数',
    [METRICS.CLICKS]: '点击次数',
    [METRICS.CTR]: '点击率',
    [METRICS.CPC]: '单次点击成本',
    [METRICS.CPM]: '千次展示成本',
    [METRICS.CONVERSION]: '转化数',
    [METRICS.COST_PER_CONVERSION]: '单次转化成本',
    [METRICS.CONVERSION_RATE_V2]: '转化率',
    [METRICS.GROSS_IMPRESSIONS]: '总展示次数',
    [METRICS.REAL_TIME_CONVERSION]: '实时转化数',
    [METRICS.REAL_TIME_COST_PER_CONVERSION]: '实时单次转化成本',
    [METRICS.REAL_TIME_CONVERSION_RATE_V2]: '实时转化率',
    [METRICS.SKAN_RESULT]: 'SKAN结果数',
    [METRICS.SKAN_COST_PER_RESULT]: 'SKAN单次结果成本',
    [METRICS.SKAN_RESULT_RATE]: 'SKAN结果率',
    [METRICS.SKAN_CONVERSION]: 'SKAN转化数',
    [METRICS.SKAN_COST_PER_CONVERSION]: 'SKAN单次转化成本',
    [METRICS.SKAN_CONVERSION_RATE_V2]: 'SKAN转化率',

    // 互动指标
    [METRICS.ENGAGEMENTS]: '互动次数',
    [METRICS.ENGAGEMENT_RATE]: '互动率',
    [METRICS.LIKES]: '点赞',
    [METRICS.COMMENTS]: '评论',
    [METRICS.SHARES]: '分享',
    [METRICS.FOLLOWS]: '关注',
    [METRICS.PROFILE_VISITS]: '主页访问',
    [METRICS.PROFILE_VISITS_RATE]: '主页访问率',
    [METRICS.CLICKS_ON_MUSIC_DISC]: '音乐点击',
    [METRICS.DUET_CLICKS]: '合拍点击',
    [METRICS.STITCH_CLICKS]: '剪映点击',
    [METRICS.SOUND_USAGE_CLICKS]: '使用音频点击',
    [METRICS.ANCHOR_CLICKS]: '锚点点击',
    [METRICS.ANCHOR_CLICK_RATE]: '锚点点击率',

    // 视频指标
    [METRICS.VIDEO_PLAY_ACTIONS]: '视频播放',
    [METRICS.VIDEO_WATCHED_2S]: '2秒播放',
    [METRICS.VIDEO_WATCHED_6S]: '6秒播放',
    [METRICS.VIDEO_VIEWS_P25]: '25%播放',
    [METRICS.VIDEO_VIEWS_P50]: '50%播放',
    [METRICS.VIDEO_VIEWS_P75]: '75%播放',
    [METRICS.VIDEO_VIEWS_P100]: '100%播放',
    [METRICS.AVERAGE_VIDEO_PLAY]: '平均播放时长',
    [METRICS.ENGAGED_VIEW]: '6秒有效观看',
    [METRICS.PAID_ENGAGED_VIEW]: '6秒有效观看(付费)',
    [METRICS.ENGAGED_VIEW_15S]: '15秒有效观看',
    [METRICS.PAID_ENGAGED_VIEW_15S]: '15秒有效观看(付费)',

    // 应用转化指标
    [METRICS.APP_INSTALL]: '应用安装',
    [METRICS.COST_PER_APP_INSTALL]: '单次安装成本',
    [METRICS.REAL_TIME_APP_INSTALL]: '实时应用安装',
    [METRICS.REAL_TIME_COST_PER_APP_INSTALL]: '实时单次安装成本',
    [METRICS.REGISTRATION]: '注册',
    [METRICS.COST_PER_REGISTRATION]: '单次注册成本',
    [METRICS.REGISTRATION_RATE]: '注册率',
    [METRICS.TOTAL_REGISTRATION]: '总注册数',
    [METRICS.PURCHASE]: '购买',
    [METRICS.COST_PER_PURCHASE]: '单次购买成本',
    [METRICS.PURCHASE_RATE]: '购买率',
    [METRICS.TOTAL_PURCHASE]: '总购买数',
    [METRICS.TOTAL_PURCHASE_VALUE]: '购买价值',
    [METRICS.PURCHASE_ROAS]: '购买ROAS',
    [METRICS.APP_EVENT_ADD_TO_CART]: '加购',
    [METRICS.COST_PER_APP_EVENT_ADD_TO_CART]: '单次加购成本',
    [METRICS.CHECKOUT]: '结算',
    [METRICS.COST_PER_CHECKOUT]: '单次结算成本',
    [METRICS.VIEW_CONTENT]: '查看内容',
    [METRICS.COST_PER_VIEW_CONTENT]: '单次查看内容成本',
    [METRICS.NEXT_DAY_OPEN]: '次日留存',
    [METRICS.DAY7_RETENTION]: '7日留存',
    [METRICS.ADD_PAYMENT_INFO]: '添加支付信息',
    [METRICS.COST_PER_ADD_PAYMENT_INFO]: '单次添加支付信息成本',
    [METRICS.LAUNCH_APP]: '启动应用',
    [METRICS.COST_PER_LAUNCH_APP]: '单次启动成本',
    [METRICS.COMPLETE_TUTORIAL]: '完成教程',
    [METRICS.COST_PER_COMPLETE_TUTORIAL]: '单次完成教程成本',

    // SKAN指标
    [METRICS.SKAN_APP_INSTALL]: 'SKAN应用安装',
    [METRICS.SKAN_COST_PER_APP_INSTALL]: 'SKAN单次安装成本',
    [METRICS.SKAN_APP_INSTALL_WITHHELD]: 'SKAN应用安装(隐私保护)',
    [METRICS.SKAN_REGISTRATION]: 'SKAN注册',
    [METRICS.SKAN_COST_PER_REGISTRATION]: 'SKAN单次注册成本',
    [METRICS.SKAN_PURCHASE]: 'SKAN购买',
    [METRICS.SKAN_COST_PER_PURCHASE]: 'SKAN单次购买成本',
    [METRICS.SKAN_TOTAL_PURCHASE_VALUE]: 'SKAN购买价值',
    [METRICS.SKAN_TOTAL_REPETITIVE_ACTIVE_PAY_ROAS]: 'SKAN购买ROAS',

    // 网站指标
    [METRICS.COMPLETE_PAYMENT]: '网站购买',
    [METRICS.COST_PER_COMPLETE_PAYMENT]: '网站单次购买成本',
    [METRICS.COMPLETE_PAYMENT_ROAS]: '网站购买ROAS',
    [METRICS.TOTAL_LANDING_PAGE_VIEW]: '落地页浏览',
    [METRICS.COST_PER_LANDING_PAGE_VIEW]: '单次落地页浏览成本',
    [METRICS.LANDING_PAGE_VIEW_RATE]: '落地页浏览率',
    [METRICS.WEBSITE_TOTAL_ENGAGED_SESSION]: '互动会话',
    [METRICS.WEBSITE_ENGAGED_SESSION_RATE]: '互动会话率',
    [METRICS.WEBSITE_COST_PER_ENGAGED_SESSION]: '单次互动会话成本',
    [METRICS.TOTAL_PAGEVIEW]: '页面浏览',
    [METRICS.COST_PER_PAGEVIEW]: '单次页面浏览成本',
    [METRICS.BUTTON_CLICK]: '按钮点击',
    [METRICS.COST_PER_BUTTON_CLICK]: '单次按钮点击成本',
    [METRICS.ONLINE_CONSULT]: '在线咨询',
    [METRICS.COST_PER_ONLINE_CONSULT]: '单次咨询成本',
    [METRICS.USER_REGISTRATION]: '网站注册',
    [METRICS.COST_PER_USER_REGISTRATION]: '网站单次注册成本',
    [METRICS.PAGE_CONTENT_VIEW_EVENTS]: '内容浏览',
    [METRICS.COST_PER_PAGE_CONTENT_VIEW_EVENT]: '单次内容浏览成本',
    [METRICS.WEB_EVENT_ADD_TO_CART]: '网站加购',
    [METRICS.COST_PER_WEB_EVENT_ADD_TO_CART]: '网站单次加购成本',
    [METRICS.ON_WEB_ORDER]: '下单',
    [METRICS.COST_PER_ON_WEB_ORDER]: '单次下单成本',
    [METRICS.INITIATE_CHECKOUT]: '发起结算',
    [METRICS.COST_PER_INITIATE_CHECKOUT]: '单次发起结算成本',
    [METRICS.ADD_BILLING]: '添加账单',
    [METRICS.COST_PER_ADD_BILLING]: '单次添加账单成本',
    [METRICS.PAGE_EVENT_SEARCH]: '搜索',
    [METRICS.COST_PER_PAGE_EVENT_SEARCH]: '单次搜索成本',
    [METRICS.FORM]: '表单提交',
    [METRICS.COST_PER_FORM]: '单次表单成本',
    [METRICS.DOWNLOAD_START]: '下载',
    [METRICS.COST_PER_DOWNLOAD_START]: '单次下载成本',
    [METRICS.ON_WEB_ADD_TO_WISHLIST]: '添加收藏',
    [METRICS.COST_PER_ON_WEB_ADD_TO_WISHLIST]: '单次添加收藏成本',
    [METRICS.ON_WEB_SUBSCRIBE]: '订阅',
    [METRICS.COST_PER_ON_WEB_SUBSCRIBE]: '单次订阅成本',

    // TikTok站内指标
    [METRICS.ONSITE_TOTAL_PURCHASE]: '站内购买',
    [METRICS.ONSITE_COST_PER_PURCHASE]: '站内单次购买成本',
    [METRICS.ONSITE_PURCHASES_ROAS]: '站内购买ROAS',
    [METRICS.ONSITE_TOTAL_CHECKOUT_INITIATION]: '站内发起结算',
    [METRICS.ONSITE_COST_PER_CHECKOUT_INITIATION]: '站内单次发起结算成本',
    [METRICS.ONSITE_TOTAL_ADD_TO_CART]: '站内加购',
    [METRICS.ONSITE_COST_PER_ADD_TO_CART]: '站内单次加购成本',
    [METRICS.ONSITE_TOTAL_PRODUCT_DETAILS_PAGE_VIEW]: '站内商品详情浏览',
    [METRICS.ONSITE_COST_PER_PRODUCT_DETAILS_PAGE_VIEW]: '站内单次商品详情浏览成本',
    [METRICS.ONSITE_UNIQUE_REGISTRATION]: '站内注册',
    [METRICS.ONSITE_COST_PER_UNIQUE_REGISTRATION]: '站内单次注册成本',
    [METRICS.ONSITE_FORM]: '站内表单',
    [METRICS.ONSITE_COST_PER_FORM]: '站内单次表单成本',
    [METRICS.ONSITE_DOWNLOAD_START]: '站内下载',
    [METRICS.ONSITE_COST_PER_DOWNLOAD_START]: '站内单次下载成本',

    // 离线指标
    [METRICS.OFFLINE_SHOPPING_EVENTS]: '线下购买',
    [METRICS.OFFLINE_COST_PER_SHOPPING_EVENT]: '线下单次购买成本',
    [METRICS.OFFLINE_SHOPPING_EVENTS_ROAS]: '线下购买ROAS',
    [METRICS.OFFLINE_CONTACT_EVENTS]: '线下联系',
    [METRICS.OFFLINE_COST_PER_CONTACT_EVENT]: '线下单次联系成本',
    [METRICS.OFFLINE_FORM_EVENTS]: '线下表单',
    [METRICS.OFFLINE_COST_PER_FORM_EVENT]: '线下单次表单成本',

    // 互动插件指标
    [METRICS.INTERACTIVE_ADD_ON_IMPRESSIONS]: '互动插件展示',
    [METRICS.INTERACTIVE_ADD_ON_DESTINATION_CLICKS]: '互动插件点击',
    [METRICS.INTERACTIVE_ADD_ON_ACTIVITY_CLICKS]: '互动活动点击',
    [METRICS.COUNTDOWN_STICKER_RECALL_CLICKS]: '倒计时提醒点击',

    // 消息指标
    [METRICS.MESSAGING_TOTAL_CONVERSATION_TIKTOK_DIRECT_MESSAGE]: 'TikTok私信会话',
    [METRICS.MESSAGING_COST_PER_CONVERSATION_TIKTOK_DIRECT_MESSAGE]: '单次TikTok私信会话成本',
    [METRICS.MESSAGING_TOTAL_CONVERSATION_INSTANT_MESSAGING_APP]: '即时消息会话',
    [METRICS.MESSAGING_COST_PER_CONVERSATION_INSTANT_MESSAGING_APP]: '单次即时消息会话成本'
}

// 指标描述
export const METRIC_DESCRIPTIONS = {
    [METRICS.SPEND]: '广告总花费金额',
    [METRICS.IMPRESSIONS]: '广告展示总次数',
    [METRICS.CLICKS]: '广告点击总次数',
    [METRICS.CTR]: '点击次数占展示次数的百分比',
    [METRICS.CPC]: '每次点击的平均成本',
    [METRICS.CPM]: '每千次展示的平均成本',
    [METRICS.CONVERSION]: '转化事件总次数',
    [METRICS.COST_PER_CONVERSION]: '每次转化的平均成本',
    [METRICS.CONVERSION_RATE_V2]: '转化次数占展示次数的百分比',
    [METRICS.VIDEO_PLAY_ACTIONS]: '视频开始播放的次数',
    [METRICS.VIDEO_WATCHED_2S]: '视频播放至少2秒的次数',
    [METRICS.VIDEO_WATCHED_6S]: '视频播放至少6秒的次数',
    [METRICS.VIDEO_VIEWS_P50]: '视频播放至少50%长度的次数',
    [METRICS.VIDEO_VIEWS_P100]: '视频完整播放的次数',
    [METRICS.AVERAGE_VIDEO_PLAY]: '单次视频播放的平均时长',
    [METRICS.ENGAGEMENTS]: '包含所有互动行为的点击总数',
    [METRICS.LIKES]: '点赞次数',
    [METRICS.COMMENTS]: '评论次数',
    [METRICS.SHARES]: '分享次数',
    [METRICS.FOLLOWS]: '关注次数',
    [METRICS.PROFILE_VISITS]: '主页访问次数',
    [METRICS.APP_INSTALL]: '应用安装次数',
    [METRICS.COST_PER_APP_INSTALL]: '每次应用安装的平均成本',
    [METRICS.REGISTRATION]: '注册次数',
    [METRICS.COST_PER_REGISTRATION]: '每次注册的平均成本',
    [METRICS.PURCHASE]: '购买次数',
    [METRICS.COST_PER_PURCHASE]: '每次购买的平均成本',
    [METRICS.PURCHASE_ROAS]: '购买带来的广告支出回报率',
    [METRICS.COMPLETE_PAYMENT]: '网站购买完成次数',
    [METRICS.COST_PER_COMPLETE_PAYMENT]: '每次网站购买的平均成本',
    [METRICS.COMPLETE_PAYMENT_ROAS]: '网站购买的广告支出回报率',
    [METRICS.ONSITE_TOTAL_PURCHASE]: 'TikTok站内购买次数',
    [METRICS.ONSITE_COST_PER_PURCHASE]: '每次站内购买的平均成本',
    [METRICS.ONSITE_PURCHASES_ROAS]: '站内购买的广告支出回报率',
    [METRICS.OFFLINE_SHOPPING_EVENTS]: '线下购买次数',
    [METRICS.OFFLINE_COST_PER_SHOPPING_EVENT]: '每次线下购买的平均成本',
    [METRICS.OFFLINE_SHOPPING_EVENTS_ROAS]: '线下购买的广告支出回报率',
    [METRICS.INTERACTIVE_ADD_ON_IMPRESSIONS]: '互动插件展示次数',
    [METRICS.INTERACTIVE_ADD_ON_DESTINATION_CLICKS]: '互动插件点击次数',
    [METRICS.MESSAGING_TOTAL_CONVERSATION_TIKTOK_DIRECT_MESSAGE]: '通过TikTok私信发起的会话数',
    [METRICS.MESSAGING_TOTAL_CONVERSATION_INSTANT_MESSAGING_APP]: '通过即时通讯应用发起的会话数'
}



// ==================== 广告组相关常量 ====================

// 优化目标
export const OPTIMIZATION_GOAL = {
    CLICK: 'CLICK',
    INSTALL: 'INSTALL',
    IN_APP_EVENT: 'IN_APP_EVENT',
    VALUE: 'VALUE',
    CONVERT: 'CONVERT',
    TRAFFIC_LANDING_PAGE_VIEW: 'TRAFFIC_LANDING_PAGE_VIEW',
    LEAD_GENERATION: 'LEAD_GENERATION'
}

export const OPTIMIZATION_GOAL_LABEL = {
    [OPTIMIZATION_GOAL.CLICK]: '点击',
    [OPTIMIZATION_GOAL.INSTALL]: '应用安装',
    [OPTIMIZATION_GOAL.IN_APP_EVENT]: '应用内事件',
    [OPTIMIZATION_GOAL.VALUE]: '价值',
    [OPTIMIZATION_GOAL.CONVERT]: '转化',
    [OPTIMIZATION_GOAL.TRAFFIC_LANDING_PAGE_VIEW]: '落地页浏览',
    [OPTIMIZATION_GOAL.LEAD_GENERATION]: '销售线索'
}

// 出价策略
export const BID_TYPE = {
    NO_BID: 'BID_TYPE_NO_BID',
    CUSTOM: 'BID_TYPE_CUSTOM'
}

export const BID_TYPE_LABEL = {
    [BID_TYPE.NO_BID]: '最大转化（系统自动出价）',
    [BID_TYPE.CUSTOM]: '成本控制（手动出价）'
}

// 投放位置
export const PLACEMENT = {
    TIKTOK: 'PLACEMENT_TIKTOK',
    PANGLE: 'PLACEMENT_PANGLE',
    GLOBAL_APP_BUNDLE: 'PLACEMENT_GLOBAL_APP_BUNDLE'
}

export const PLACEMENT_LABEL = {
    [PLACEMENT.TIKTOK]: 'TikTok',
    [PLACEMENT.PANGLE]: 'Pangle',
    [PLACEMENT.GLOBAL_APP_BUNDLE]: 'Global App Bundle'
}

// 性别定向
export const GENDER = {
    FEMALE: 'GENDER_FEMALE',
    MALE: 'GENDER_MALE',
    UNLIMITED: 'GENDER_UNLIMITED'
}

export const GENDER_LABEL = {
    [GENDER.FEMALE]: '女性',
    [GENDER.MALE]: '男性',
    [GENDER.UNLIMITED]: '不限'
}

// ==================== 指标定义（基于 API 文档） ===================
// 广告格式
export const AD_FORMAT = {
    SINGLE_VIDEO: 'SINGLE_VIDEO',
    CAROUSEL_ADS: 'CAROUSEL_ADS',
    CATALOG_CAROUSEL: 'CATALOG_CAROUSEL'
}

export const AD_FORMAT_LABEL = {
    [AD_FORMAT.SINGLE_VIDEO]: '单视频',
    [AD_FORMAT.CAROUSEL_ADS]: '轮播图',
    [AD_FORMAT.CATALOG_CAROUSEL]: '商品轮播'
}